/**
 * tor-cart-fix.js — Toriara Naturals
 *
 * Bridges the gap between Impulse theme (native fetch API) and
 * MLV Doubly currency converter (listens only to jQuery ajaxComplete).
 *
 * Problems solved:
 *  1. Cart subtotal blank after AJAX add — re-wraps in span.money so
 *     Doubly can find and convert it.
 *  2. Cart item prices not re-converted after add/qty-change — manually
 *     triggers DoublyCurrency.convertAll after every cart mutation.
 *  3. Qty changes in cart drawer also trigger re-conversion.
 *
 * Safe to load on all pages — all selectors are guarded.
 * Zero dependencies — pure vanilla JS.
 */
(function () {
  'use strict';

  /* ── Helper: run Doubly conversion and re-wrap subtotal ── */
  function syncDoubly() {
    /* 1. Re-wrap [data-subtotal] in span.money if Impulse stripped it */
    var subtotalEl = document.querySelector('[data-subtotal]');
    if (subtotalEl) {
      var inner = subtotalEl.innerHTML.trim();
      /* Only re-wrap if there's content but no span.money wrapper */
      if (inner && !subtotalEl.querySelector('span.money')) {
        subtotalEl.innerHTML = '<span class="money">' + inner + '</span>';
      }
    }

    /* 2. Call DoublyCurrency.convertAll with the currently selected currency */
    if (window.DoublyCurrency && typeof DoublyCurrency.convertAll === 'function') {
      var currSelect = document.querySelector('[name="doubly-currencies"]');
      var currency = currSelect ? currSelect.value : (DoublyCurrency.currentCurrency || '');
      if (currency) {
        DoublyCurrency.convertAll(currency);
      }
    }
  }

  /* ── Listen to Impulse's native cart events ── */

  /* Fired by Impulse (and our custom ATC) after item successfully added */
  document.addEventListener('ajaxProduct:added', function () {
    /* Small delay: allow theme.min.js to finish writing subtotal HTML first */
    setTimeout(syncDoubly, 120);
  });

  /* Fired by Impulse after cart quantity change (+ / - buttons) */
  document.addEventListener('cart:updated', function () {
    setTimeout(syncDoubly, 120);
  });

  /* Fired by theme after cart is rebuilt via buildCart() */
  document.addEventListener('cart:build', function () {
    setTimeout(syncDoubly, 120);
  });

  /* ── Also hook Doubly's own currency change ── */
  /* When the visitor switches currency, re-wrap subtotal so it gets converted */
  var doublySelect = document.querySelector('[name="doubly-currencies"]');
  if (doublySelect) {
    doublySelect.addEventListener('change', function () {
      setTimeout(syncDoubly, 80);
    });
  }

  /* Observe DOM for the currency switcher appearing late (Doubly injects it async) */
  if (!doublySelect && 'MutationObserver' in window) {
    var switcherObserver = new MutationObserver(function (mutations, obs) {
      var sel = document.querySelector('[name="doubly-currencies"]');
      if (sel) {
        sel.addEventListener('change', function () {
          setTimeout(syncDoubly, 80);
        });
        obs.disconnect();
      }
    });
    switcherObserver.observe(document.body, { childList: true, subtree: true });
  }

  /* ── Initial sync on page load ── */
  /* Runs once DOM is ready, after Doubly has had time to init (~400ms) */
  function initialSync() {
    setTimeout(syncDoubly, 500);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialSync);
  } else {
    initialSync();
  }

})();
